import { useState } from "react";
import axios from "axios";

const useDelete = (route: string) => {
	const [loading, setLoading] = useState(false);

	const deleteFunction = async () => {
		setLoading(true);
		return axios
			.delete(route)
			.then(({ data }) => data)
			.finally(() => setLoading(false));
	};

	return [deleteFunction, loading] as [() => Promise<any>, boolean];
};

export default useDelete;
